import { CalendarIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link, Route, Routes, useLocation } from "react-router-dom";

import { Actions as PAYMENT_ACTIONS } from "../../../store/actions/paymentActions";
import { useEffect } from "react";
import AdvisorBilling from "./AdvisorBillingInfo";
import BillingEmails from "@/components/billing/BillingEmails";
import CreditHistory from "./CreditHistory";

const tabs = [
	{
		link: "/advisor/billing",
		name: "Information",
	},
	{
		link: "/advisor/billing/credit-history",
		name: "Credit History",
	},
	{
		link: "/advisor/billing/emails",
		name: "Billing Emails",
	},
];

const AdvisorBillingNavigation = ({ isAdmin, creditBalance, activeAdvisors, clients, getAdvisorCredits }) => {
	const location = useLocation();
	const currentTab = location.pathname;

	useEffect(() => {
		getAdvisorCredits();
	}, []);

	return (
		<>
			<div className="content bg-gray-lighter">
				<div className="row">
					<div className="col-sm-12">
						<div className="pull-left">
							<h1 className="page-heading">Billing</h1>
						</div>
					</div>
				</div>
				<div
					className="row items-push text-uppercase"
					style={{ paddingTop: 0, paddingBottom: 0 }}
				>
					<div className="col-xs-6 col-sm-3">
						<div
							className="font-w700 text-gray-darker"
							id="total"
						>
							Credit Balance
						</div>
						<div className="text-muted animated fadeIn">
							<small>
								<CalendarIcon style={{ height: "1em" }} /> Now
							</small>
						</div>
						<Link
							to="/advisor/credit-history"
							className="h2 font-w300 text-primary animated"
							href="#"
						>
							{creditBalance || 0}
						</Link>
					</div>
					<div className="col-xs-6 col-sm-3">
						<div
							className="font-w700 text-gray-darker"
							id="active"
						>
							Clients
						</div>
						<div className="text-muted animated fadeIn">
							<small>
								<CalendarIcon style={{ height: "1em" }} /> To Date
							</small>
						</div>
						<Link
							to="/advisor"
							className="h2 font-w300 text-primary animated"
							href="#"
						>
							{clients || 0}
						</Link>
					</div>
					<div className="col-xs-6 col-sm-3">
						<div
							className="font-w700 text-gray-darker"
							id="tax-paid"
						>
							Active Advisors
						</div>
						<div className="text-muted animated fadeIn">
							<small>
								<CalendarIcon style={{ height: "1em" }} /> Now
							</small>
						</div>
						<Link
							to="/advisor/team"
							className="h2 font-w300 text-primary animated"
						>
							{activeAdvisors || 0}
						</Link>
					</div>
				</div>
			</div>
			<ul className="nav nav-tabs nav-tabs-alt nav-justified">
				{tabs.map((tab) => {
					if (tab.show && !tab.show(isAdmin)) return null;

					return (
						<li className={currentTab === tab.link ? "active" : ""}>
							<Link to={tab.link}>{tab.name}</Link>
						</li>
					);
				})}
			</ul>
			<Routes>
				<Route
					path="*"
					element={<AdvisorBilling />}
				/>
				<Route
					path="emails"
					element={<BillingEmails forAdvisor={true} />}
				/>
				<Route
					path="credit-history"
					element={<CreditHistory />}
				/>
			</Routes>
		</>
	);
};

const mapStateToProps = (state) => {
	const { credits } = state?.advisor || {};

	return {
		isAdmin: state.my.profile.isAdmin,
		creditBalance: credits?.sort((a, b) => new Date(b.date) - new Date(a.date))[0]?.balance,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getAdvisorCredits: (before, after) => dispatch(PAYMENT_ACTIONS.getAdvisorCredits({ before, after })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvisorBillingNavigation);
